<template>
    <article class='xbed-oms-content'>
        <section class='xbed-sub-title'>
            <span>交易流水</span>
        </section>
        <section style='marginTop:20px'>
            <Form :model='transaction' ref='transaction'>
                <Row>
                     <Col span='5'>
                        <FormItem prop='' label='交易时间' :label-width='120'>
                            <date-picker type='daterange' :model='transaction.datePick' :value='transaction.datePick' @on-change="datepick" style='width:100%'></date-picker>
                        </FormItem>
                    </Col>
                    <Col span='5'>
                        <FormItem prop='' label='交易类型' :label-width='120'>
                            <Select v-model='transaction.type'>
                                <Option v-for='status in transactionType' :key='status.id' :value='status.id'>{{status.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span='5'>
                        <FormItem prop='' label='交易状态' :label-width='120'>
                            <Select v-model='transaction.status'>
                                <Option v-for='status in transactionStutas' :key='status.id' :value='status.id'>{{status.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span='5'>
                        <FormItem prop='' label='支付方式' :label-width='120'>
                            <Select v-model='transaction.payWay'>
                                <Option v-for='status in transactionPayWay' :key='status.id' :value='status.id'>{{status.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <!-- <Col span="5">
                         <FormItem prop='' label='Xbed订单号' :label-width='120' >
                            <Input type='text' v-model='transaction.xbedOrder'></Input>
                        </FormItem>
                    </Col> -->
                    <Col span="5">
                         <FormItem prop='' label='艺龙订单号' :label-width='120' >
                            <Input type='text' v-model='transaction.elongOrder'></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span='3' offset="1">
                        <FormItem>
                            <Button type='primary' @click='queryOrderList'>查询</Button>
                        </FormItem>
                    </Col>
                </Row>
                <Table stripe :loading='transactionLoading' :width="tableWidth"  height="650" :columns="transactionList" :data="transactionData.list">
                </Table>
                <div style="margin: 10px;overflow: hidden">
                    <Page show-sizer placement="top" :total="transactionData.total" :current="transaction.page" :page-size="transaction.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
                </div>
            </Form>
        </section>
    </article>
</template>
<script>
import Moment from 'moment';
// import {phoneRegular} from "../../utils/regular"
import API from "../../api";
import Utils from '../../utils';

export default{
    data (){
        return {
            tableWidth: 0,
            transactionType:[
                {
                    name:'全部',
                    id:99
                },
                {
                    name:'支付',
                    id:1
                },
                {
                    name:'退款',
                    id:2
                }
            ],
            transactionStutas:[
                {
                    name:'全部',
                    id:99
                },
                {
                    name:'未支付',
                    id:0
                },
                {
                    name:'已支付',
                    id:1
                },
                {
                    name:'待退款',
                    id:2
                },
                {
                    name:'已退款',
                    id:3
                },
                {
                    name:'支付失败',
                    id:4
                }
            ],
            transactionPayWay:[
                {
                    name:'全部',
                    id:99
                },
                {
                    name:'IOS',
                    id:2
                },
                {
                    name:'android',
                    id:3
                },
                {
                    name:'小程序',
                    id:14
                }
            ],
            transaction:{
                type: 99,
                status: 99,
                payWay: 99,
                xbedOrder: '',
                elongOrder:'',
                page: 1,
                pageSize: 10,
                datePick:[Moment().subtract(29, 'days').format('YYYY-MM-DD'), Moment().format('YYYY-MM-DD')],
            },
            transactionData:{
                list:[]
            },
            transactionLoading: false,
            transactionList:[
                {
                    title:'订单号',
                    key:'outOrderId',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'交易单号',
                    key:'tradeNo',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'创建时间',
                    key:'ctime',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'交易时间',
                    key:'tradeTime',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'交易类型',
                    key:'tradeType',
                    minWidth:150,
                    align: 'center',
                    render:(h,params)=>{
                         let pay = ['','支付','退款'][params.row.tradeType]
                        return h('div',{}, pay)
                    }
                },
                {
                    title:'原因',
                    key:'reason',
                    minWidth:150,
                    align: 'center',
                    // render:(h,params)=>{
                    //      let pay = 
                    //     return h('div',{}, pay)
                    // }
                },
                {
                    title:'交易状态',
                    key:'payStatus',
                    minWidth:150,
                    align: 'center',
                    // render:(h,params)=>{
                    //      let pay = ['全部','支付成功','待退款','已退款'][params.row.payStatus]
                    //     return h('div',{}, pay)
                    // }
                },
                {
                    title:'支付方式',
                    key:'sourceType',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'交易金额',
                    key:'amount',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'第三方流水号',
                    key:'outNo',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'备注',
                    key:'remark',
                    minWidth:150,
                    align: 'center',
                }
            ]
        }
    },
    methods:{
        datepick(dataArr){
            this.transaction.datePick = dataArr;
        },
        async queryOrderList(){
            this.transaction.page = 1;
            this.transactionLoading = true;
            let params = this.initAjaxParams();
            let respData = (await API.omsAPI[this.env].elong.queryTransactionList(params,this.token)).data;
            this.transactionData = respData.data;
            this.transactionLoading = false;
        },
        initAjaxParams(){
            let params= {
                end_date: this.transaction.datePick[1],
                start_date: this.transaction.datePick[0],
                source_type: this.transaction.payWay,
                pay_status: this.transaction.status,
                trade_type: this.transaction.type,
                page_num: this.transaction.page,
                page_size: this.transaction.pageSize,
                order_id: this.transaction.xbedOrder,
                out_order_id:this.transaction.elongOrder
            }
            if(this.transaction.status == 99 && this.transaction.status != 0){
                delete params['pay_status']
            }
            if(this.transaction.type == 99){
                delete params['trade_type']
            }
            if(this.transaction.payWay == 99){
                delete params['source_type']
            }
            for(let key in params){
                if(!params[key] && parseFloat(params[key]) !== 0){
                    delete params[key]
                }
            }
            return params;
        },
        async changePage(pageIndex) {
            this.transaction.page = pageIndex;
            this.transactionLoading = true;
            let params = this.initAjaxParams();
            let respData = (await API.omsAPI[this.env].elong.queryTransactionList(params,this.token)).data;
            this.transactionData = respData.data;
            this.transactionLoading = false;
        },
        changePageSize(pageSize){
            this.transaction.page = 1;
            this.transaction.pageSize = pageSize;
        },
    },
    created(){
        this.token = Utils.findFromLocalStorage('vue-token');
        this.env = Utils.findFromLocalStorage('env','dev');
        this.userId = Utils.findFromLocalStorage('vue-userid');
        this.tableWidth = window.screen.width - 235;
        
    },
    async mounted(){
        this.transactionLoading = true;
        let params = this.initAjaxParams();
        let respData = (await API.omsAPI[this.env].elong.queryTransactionList(params,this.token)).data;
        this.transactionData = respData.data;
        // this.transaction.page++;
        console.info(this.transactionData);
        this.transactionLoading = false;
    }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/pages/elong/transactionRecord.vue